/* eslint-disable */
import React from "react";
import RenderAdminPage from "../RenderAdminPage";
import FundContributionAnalysisPanel from "../../Components/FundContributionAnalysisPanel";

function LoanDeductionAnalysis() {
  return (
    <RenderAdminPage title="Loan Deduction Analysis">
      <FundContributionAnalysisPanel accent="indigo" variant="loans" />
    </RenderAdminPage>
  );
}

export default LoanDeductionAnalysis;
